export function getEnv(): string {
    // parse host name to get environment
    const host = window.location.hostname;
    if (host.includes('localhost')) {
        return 'dev';
    } else if (host.includes('sbox')) {
        return 'sbox';
    }

    return 'prod';
}
